import React from 'react';
import {DynamicQuestionMulti} from '../DynamicQuestions/DynamicQuestionMulti';
import {DynamicQuestionFreetext} from '../DynamicQuestions/DynamicQuestionFreetext';
import {Box, FormControlLabel} from "@mui/material";
import {DynamicQuestionControl} from "../DynamicQuestions/DynamicQuestionControl";

const hasTruthOrAnswerId = (childQuestions) => {
    if (!Array.isArray(childQuestions)) return false;
    for (const q of childQuestions) {

        const isValid = (val) =>
            val !== undefined &&
            val !== null &&
            !(typeof val === 'string' && val.trim() === '');

        if (isValid(q.truthOptionId) || isValid(q.answerOptionId)) {
            return true;
        }
        if (Array.isArray(q.options)) {
            for (const option of q.options) {
                if (Array.isArray(option.childQuestions)) {
                    if (hasTruthOrAnswerId(option.childQuestions)) {
                        return true;
                    }
                }
            }
        }
    }
    return false;
}

const checkShowChildQuestion = (isSelectedAnswer, disabled, childQuestions) => {
    if(!disabled) {
        return isSelectedAnswer && childQuestions && childQuestions.length > 0;
    } else {
        return hasTruthOrAnswerId(childQuestions)
    }
}

export const QuizQuestionSingle = (props) => {
    const {question, answer, truth, disabled, onChange} = props;

    const renderOptions = (option) => {
        const isTruth = truth === option.id;
        const isAnswer = answer === option.id;
        return (
            <div key={option.id}>
                <FormControlLabel
                    style={{alignItems: 'flex-start'}}
                    key={option.id}
                    value={option.id}
                    label={option.name}
                    control={<DynamicQuestionControl type="radio" isAnswer={isAnswer} isTruth={isTruth} disabled={disabled}/>}
                    checked={isTruth || isAnswer}
                    onChange={() => onChange(option.id, question.id)}
                />
                {
                    checkShowChildQuestion(isAnswer, disabled, option.childQuestions) &&  // Show child questions only if the option is selected or disabled (this means the question is being submitted)
                    <Box className="">
                        {option.childQuestions.map((child) => (
                            <div className={'ms-2 mt-1 mb-1'} key={child.id}>
                                <QuizQuestion {...props} question={child} truth={child.truthOptionId} answer={child.answerOptionId} onChange={(value, id) => props.onChange(value, id ?? child.id)}/>
                                <div className={'fs-13 ml-3'} dangerouslySetInnerHTML={{__html: question.questionExplain}}/>
                            </div>
                        ))}
                    </Box>
                }
            </div>
        );
    };

    return <div>
        <div className="fs-20 fw-semi-bold" style={{whiteSpace: 'pre-line'}}>{question.name}</div>
        <Box className="dynamic-question-content" display="flex" flexDirection="column">
            {question.options.map((option) => renderOptions(option))}
        </Box>
    </div>;
};

export const QuizQuestion = (props) => {
    const {question, answer, truth, disabled, onChange} = props;
    switch (question.type) {
        case 'single':
            return <QuizQuestionSingle {...props} onChange={(value, id) => props.onChange(value, id)}/>;
        case 'multi':
            return <DynamicQuestionMulti {...props}/>;
        case 'freetext':
            return <DynamicQuestionFreetext {...props}/>;
        case 'annotation':
            return <div>
                <div className="fs-20 fw-semi-bold">{props.question.name}</div>
            </div>
        default:
            return null;
    }
};
